import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { EmptyStateWrapper, ButtonType } from '@checkmarx/cx-ui';
import SecurityTabs from './tabs';
import ScreenLoaderContainer from '../../portal/controls/screenLoaderContainer';
import PasswordPolicySettings from '../passwordPolicySettings';
import LockoutPolicySettings from '../lockoutPolicySettings';
import TwoFactorAuthSettings from '../twoFactorAuthSettings';
import LoginSettings from '../loginSettings';
import ConfirmationDialog from '../../portal/dialogs/confirmationDialog';

@inject('translationsStore','routesStore') @observer
export default class SecurityTabsContainer extends Component {

    setSelectedTabId = tab => {
        this.props.routesStore.setSelectedSecurityTab(tab.props['value']);
    }
   
    handleActive = tab => {
        if (this.props.routesStore.securitySelectedTab !== tab.props['value']) {
            this.props.routesStore.setSelectedSecurityTab(tab.props['value']);
        }
    }

    componentDidMount() {
        this.props.routesStore.setSelectedSecurityTab(1);
    }

    render() {

        const t = this.props.translationsStore.translate;
        let passwordPoliciesForm = <div><PasswordPolicySettings /></div>;
        let lockoutPoliciesForm = <div><LockoutPolicySettings /></div>;
        let twoFactorAuthForm = <div><TwoFactorAuthSettings /></div>;
        let loginForm = <div><LoginSettings/></div>
          
        const tabs = [
            {
                id: 1,
                title: t('LOGIN_SETTINGS'),
                dataCy: 'security-login-tab',
                component: loginForm
            },
            {
                id: 2,
                title: t('PASSWORD_POLICIES_TITLE'),
                dataCy: 'security-password-complexity-tab',
                component: passwordPoliciesForm
            },
            {
                id: 3,
                title: t('LOCKOUT_POLICY'),
                dataCy: 'security-lockout-policy-tab',
                component: lockoutPoliciesForm
            },
            {
                id: 4,
                title: t('MFA_AUTH'),
                dataCy: 'security-twofactor-auth-tab',
                component: twoFactorAuthForm
            }
        ];

        return (
            <div>
                <SecurityTabs
                    tabs={tabs}
                    handleActive={this.handleActive}
                    selectedTabId={this.props.routesStore.securitySelectedTab}
                />
            </div>
        );
    }
}